import { FunctionField, FunctionFieldProps } from 'react-admin';
import { TagUsageCalculations } from './TagUsageCalculations';

interface TagFieldProps extends Partial<FunctionFieldProps> {
  label?: string;
}

export const TagRemainingField = (props: TagFieldProps) => (
  <FunctionField
    textAlign="left"
    {...props}
    render={(record: { weight: number; consumedGrams: number }) => {
      if (!record.weight) return '-';
      const remaining = TagUsageCalculations.calculateRemaining(
        record.weight,
        record.consumedGrams
      );
      return (
        <span
          style={{
            color: TagUsageCalculations.getRemainingColor(record.weight, record.consumedGrams),
          }}
        >
          {remaining.toFixed(2)}
        </span>
      );
    }}
    sortable={false}
  />
);

export const TagUsagePercentageField = (props: TagFieldProps) => (
  <FunctionField
    textAlign="left"
    {...props}
    render={(record: { weight: number; consumedGrams: number }) => {
      if (!record.weight) return '-';
      const percentage = TagUsageCalculations.calculatePercentage(
        record.weight,
        record.consumedGrams
      );
      return (
        <span
          style={{
            color: TagUsageCalculations.getPercentageColor(record.weight, record.consumedGrams),
          }}
        >
          {percentage.toFixed(1)}%
        </span>
      );
    }}
    sortable={false}
  />
);
